import React from "react";
import {Navigate, Outlet} from "react-router-dom";

const VerifyAdmin = props => {
  const {session} = props;

  //if (session?.profile !== 1) return <Navigate replace to="/cermaq/" />;

  return <Outlet />;
};

export default VerifyAdmin;

